import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDkN8dX6sP-33FheP3avsNgUXWOk2JW_Xg",
  authDomain: "testimonial-wall-85dfc.firebaseapp.com",
  projectId: "testimonial-wall-85dfc",
  storageBucket: "testimonial-wall-85dfc.firebasestorage.app",
  messagingSenderId: "119364715488",
  appId: "1:119364715488:web:49ba29c2f1f19b8fd5e185"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
